import React, { useState, useEffect } from 'react';
import { Calculator, X } from 'lucide-react';
import { PricingWidgetCore } from '../../pages/ComparePricingPage';

/**
 * StickyQuoteButton — global floating "Get Custom Quote" CTA.
 * Bottom-LEFT (mirrors WhatsApp widget on bottom-right).
 * Opens a centered modal that hosts the full <PricingWidgetCore /> in embedded mode.
 */
const StickyQuoteButton = () => {
  const [open, setOpen] = useState(false);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    if (open) {
      window.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <>
      {/* Floating button — bottom-left, mirrors WhatsApp on the right */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 left-6 z-40 group flex items-center gap-2 pl-4 pr-5 py-3 bg-gradient-to-r from-rose-600 to-orange-600 text-white font-bold rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all"
        aria-label="Get Custom Quote"
        data-testid="sticky-quote-button"
      >
        <Calculator className="w-5 h-5" />
        <span className="hidden sm:inline">Get Custom Quote</span>
        <span className="sm:hidden">Quote</span>
      </button>

      {/* Modal */}
      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto"
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
          data-testid="quote-modal"
        >
          <div className="w-full max-w-3xl my-8">
            <PricingWidgetCore
              embedded
              source="sticky-modal"
              onClose={() => setOpen(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default StickyQuoteButton;
